import React from 'react';
import PropTypes from 'prop-types';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import { Statistic, Icon } from 'semantic-ui-react';

import TargetLink from '../target-link';

const textCenter = {
  textAlign: 'center',
};

const UpgradeModal = ({
  onClose,
  value,
}) => (
  <DyzioModal
    onClose={onClose}
    size="tiny"
    hasActionButton
    actionButtonContent="maybe later!"
    headerText={`Great Work! You've added ${value} influencers`}
  >
    <div style={textCenter}>
      <Statistic size="large">
        <Statistic.Value>{ value }</Statistic.Value>
        <Statistic.Label>
          <Icon name="user outline" color="pink" />
          influencers
        </Statistic.Label>
      </Statistic>
    </div>
    <br />
    <p>
      To add more than 50 influencers to your private My Influencers database
      contact our sales team using the Intercom button in the bottom right hand corner of the screen.
      Check out our pricing options <TargetLink renderIf href="https://dyzio.co/pricing">here</TargetLink>.
    </p>
  </DyzioModal>
);

UpgradeModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
};

export default UpgradeModal;



/** WEBPACK FOOTER **
 ** ./src/components/upgrade-modal/index.js
 **/